
const Step = ({title, step, currentStep}) => {

    const isPreviousStep = step < currentStep;
    const isNextStep = step > currentStep;

    return (
        <div className="tw-flex tw-flex-col tw-items-start tw-gap-3 tw-w-[306px] sm:tw-w-auto sm:tw-flex-[1_0_0%]">
            <div className="tw-flex tw-flex-col tw-items-start tw-flex-[1_0_0%]">
                <span className={`tw-text-body-small-bold ${isNextStep ? "tw-text-mutelios-blue-light" : "tw-text-mutelios-blue"}`}>Étape {step}</span>
                <div className="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-self-stretch">
                    <img className={`${isPreviousStep ? "" : "tw-hidden"}`} src="/o/mutelios-theme-css/icons/CheckCircle.svg" alt=""/>
                    <span className={`tw-text-body-lead-bold ${isNextStep ? "tw-text-mutelios-blue-light" : "tw-text-mutelios-blue"}`}>{title}</span>
                </div>
            </div>
            <img src={`${isNextStep ? "/o/mutelios-theme-css/icons/BarBlueLight.svg" : "/o/mutelios-theme-css/icons/Bar.svg"}`} alt=""/>
        </div>
    );
}

export default Step;
